import { PropTypes } from "aem/ComponentWrapper";
import React from "react";

export default {
  title: "Virtual Agent",
  type: "rh/components/content/virtualagent",
  isContainer: true,
  config: {
    emptyLabel: "Virtual Agent",
    isEmpty: ({ children }: PropTypes) => React.Children.count(children) === 0
  }
};
